import styled from 'styled-components';

export const StyledIFrame = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 600px;
  transition: height 0.35s, opacity 0.4s 0.1s;
`;
